/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Liability_Review_UnavailableInputs */

const en_api_error_liability_review_unavailable = /** @type {(inputs: Api_Error_Liability_Review_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liability review is unavailable for this case.`)
};

const pt_br2_api_error_liability_review_unavailable = /** @type {(inputs: Api_Error_Liability_Review_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A revisão de culpabilidade não está disponível para este caso.`)
};

/**
* | output |
* | --- |
* | "Liability review is unavailable for this case." |
*
* @param {Api_Error_Liability_Review_UnavailableInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_liability_review_unavailable = /** @type {((inputs?: Api_Error_Liability_Review_UnavailableInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Liability_Review_UnavailableInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_liability_review_unavailable(inputs)
	return pt_br2_api_error_liability_review_unavailable(inputs)
});